import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface GraphUpIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const GraphUpIcon = ({ className, ...props }: GraphUpIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 3.25C4.41421 3.25 4.75 3.58579 4.75 4V14.7686L11.4873 8.45312C11.7826 8.17627 12.244 8.18349 12.5303 8.46973L15 10.9395L18.9697 6.96973C19.2626 6.67683 19.7374 6.67683 20.0303 6.96973C20.3232 7.26262 20.3232 7.73738 20.0303 8.03027L15.5303 12.5303C15.2557 12.8049 14.8209 12.8223 14.5264 12.582L14.4697 12.5303L11.9824 10.0439L4.75 16.8242V19.25H20C20.4142 19.25 20.75 19.5858 20.75 20C20.75 20.4142 20.4142 20.75 20 20.75H4C3.58579 20.75 3.25 20.4142 3.25 20V4C3.25 3.58579 3.58579 3.25 4 3.25Z"
      fill="currentColor"
    />
  </svg>
);

export default GraphUpIcon;
